<!--
 * @Author: joejoe 2508751008@qq.com
 * @Date: 2022-07-12 09:30:07
 * @LastEditors: joejoe 2508751008@qq.com
 * @LastEditTime: 2022-07-12 10:20:15
 * @FilePath: /com.hwaqing.web.pricecalc/src/components/points/points.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <span :class="starCountClass">
            <span style="display: flex">
                <span class="ml10">{{ label }}</span>
                <span class="ml10">
                    <el-input-number size="mini" v-model="count" style="width: 100px;"
                        ref="endStarCount" @change="onChange" :max="max"></el-input-number>
                  <span class="ml10"> {{ unit }}</span>
                </span>
            </span>
        </span>

    </div>
</template>

<script>
export default {
    name: 'points',
    props: ['label','defaultCount', 'victorypoints', 'unit','max'],
    data() {
        return {
            count: 1,
            victorypointId: 0
        }
    },
    mounted() {
        this.count = this.defaultCount
    },
    methods: {
        onChange(count) {
            this.$emit('change', count)
        },
    },
}
</script>

<style scoped>
.ml10{
    margin-left: 10px;
}
</style>
